import * as React from 'react';
import NavItem from './NavItem';
import NavFlyout from './NavFlyout';
import { SecurityRoles as roles } from '../../common/utils';

interface AdminNavBarProps {
	// to?: string;
	onClick?: () => void;
	// glyph?: string;
	currentRoles?: Array<roles>;
}
const AdminNavBar: React.StatelessComponent<AdminNavBarProps> = props => {
	const allAllowedRoles = [roles.Administrator, roles.Agent, roles.Adjudicator];
	const adminAgentAuthProps = { 
		rolesRequired: [roles.Administrator, roles.Agent],
		currentRoles: props.currentRoles 
	};
	const adjudicatorAuthProps = { 
		rolesRequired: [roles.Administrator, roles.Adjudicator],
		currentRoles: props.currentRoles 
	};

	const isAuthorized = allAllowedRoles.some(role => 
		Array.isArray(props.currentRoles) 
		&& props.currentRoles.indexOf(role) >= 0
	);

	return isAuthorized ? (
		<ul className="navbar-nav navbar-nav-separator ml-xl-auto">
			<NavItem className="nav-item-heading d-xl-none">Administration</NavItem>
			<NavItem to="/admin" {...adminAgentAuthProps} onClick={props.onClick} linkExactActive={true}>
				Home
			</NavItem>
			<NavItem to="/admin/pick-lists" {...adminAgentAuthProps} onClick={props.onClick}>
				PickLists
			</NavItem>
			<NavItem to="/admin/customers" {...adminAgentAuthProps} onClick={props.onClick}>
				Customers
			</NavItem>
			<NavItem to="/admin/adjudication" {...adjudicatorAuthProps} onClick={props.onClick}>
				Adjudication
			</NavItem>
			<NavItem to="/admin/staff" {...adminAgentAuthProps} onClick={props.onClick}>
				Staff
			</NavItem>
			<NavItem to="/admin/group" {...adminAgentAuthProps} onClick={props.onClick}>
				Groups
			</NavItem>
			{/* TODO: Set toggler URL */}
			<NavFlyout
				togglerTo="#"
				togglerChildren="Reports"
				items={[
					{ to: '/admin/reports/user-activity', label: 'User activity', onClick: props.onClick },
					{ to: '/admin/reports/policies-created', label: 'Policies created', onClick: props.onClick },
					{ to: '/admin/reports/policies-unmailed', label: 'Policies not mailed', onClick: props.onClick },
					{ to: '/admin/reports/policies-expiring', label: 'Policies expiring', onClick: props.onClick },
					{ to: '/admin/reports/failed-payments', label: 'Failed payment', onClick: props.onClick },
					{
						to: '/admin/reports/missing-beneficiary-forms',
						label: 'Missing beneficiary forms',
						onClick: props.onClick
					},
					{ to: '/admin/reports/bounced-emails', label: 'Bounced emails', onClick: props.onClick },
					{ to: '/admin/reports/financial-export', label: 'Financial export', onClick: props.onClick },
					{ to: '/admin/reports/referrals', label: 'Referrals', onClick: props.onClick }
				]}
				{...adminAgentAuthProps}
			/>
		</ul>
	) : null;
};
export default AdminNavBar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/navigation/AdminNavBar.tsx